export default __webpack_public_path__ + "static/media/breakfastFasting.a0bd52ad.svg";